const services = [
  {
    id: 1,
    number: "01",
    img: "/assets/img/service/service_box_1.jpg",
    icon: "/assets/img/icon/service_box_1.svg",
    title: "Web Development",
    bgShape: "/assets/img/bg/service_card_bg.png",
    description: [
      "We build scalable and high-performance web applications using modern technologies to deliver fast, secure, and fully responsive digital experiences across all devices.",

      "Authoritatively scale business meta-services before client-based technologies. Collaboratively strategize synergistic scenarios rather than flexible action items. Continually deliver market positioning convergence and mission-critical infrastructures.",
    ],

    videoSection: {
      image: "/assets/img/service/service_inner_1.jpg",
      videoUrl: "https://www.youtube.com/watch?v=_sI_Ps7JSEk",
    },

    checklistTitle: "We Serve The Best Work",
    checklist: [
      "Up am intention on dependent questions",
      "Surrounded affronting favourable",
      "Sed ut perspiciatis unde omnis iste natus",
      "Special Careness Risk Free",
      "Bibend auctor nisi elit volume are beguiled",
    ],

    extraDescription:
      "Credibly brand accurate data after user friendly ROI. Professionally negotiate inexpensive markets and team driven scenarios. Interactively seize wireless e-tailers after resource maximizing content. Collaboratively leverage existing.",

    benefitsTitle: "Benefits With Our Service",

    features: [
      {
        icon: "/assets/img/icon/service_feature_1.svg",
        title: "Flexible Solutions",
        text: "Completely grow multimedia based content before global scenarios.",
      },
      {
        icon: "/assets/img/icon/service_feature_2.svg",
        title: "24/7 Unlimited Support",
        text: "Completely grow multimedia based content before global scenarios.",
      },
    ],
  },
  {
    id: 2,
    number: "02",
    img: "/assets/img/service/service_box_2.jpg",
    icon: "assets/img/icon/service_box_2.svg",
    title: "UI/UX Design",
    bgShape: "/assets/img/bg/service_card_bg.png",
    description: [
      "We create intuitive and visually appealing UI/UX designs using modern principles to deliver smooth, user-friendly, and highly engaging digital experiences across platforms.",

      "Authoritatively scale business meta-services before client-based technologies. Collaboratively strategize synergistic scenarios rather than flexible action items. Continually deliver market positioning convergence and mission-critical infrastructures.",
    ],

    videoSection: {
      image: "/assets/img/service/service_inner_1.jpg",
      videoUrl: "https://www.youtube.com/watch?v=_sI_Ps7JSEk",
    },

    checklistTitle: "We Serve The Best Work",
    checklist: [
      "Up am intention on dependent questions",
      "Surrounded affronting favourable",
      "Sed ut perspiciatis unde omnis iste natus",
      "Special Careness Risk Free",
      "Bibend auctor nisi elit volume are beguiled",
    ],

    extraDescription:
      "Credibly brand accurate data after user friendly ROI. Professionally negotiate inexpensive markets and team driven scenarios. Interactively seize wireless e-tailers after resource maximizing content. Collaboratively leverage existing.",

    benefitsTitle: "Benefits With Our Service",

    features: [
      {
        icon: "/assets/img/icon/service_feature_1.svg",
        title: "Flexible Solutions",
        text: "Completely grow multimedia based content before global scenarios.",
      },
      {
        icon: "/assets/img/icon/service_feature_2.svg",
        title: "24/7 Unlimited Support",
        text: "Completely grow multimedia based content before global scenarios.",
      },
    ],
  },
  {
    id: 3,
    number: "03",
    img: "/assets/img/service/service_box_3.jpg",
    icon: "/assets/img/icon/service_box_3.svg",
    title: "Digital Marketing",
    bgShape: "/assets/img/bg/service_card_bg.png",
    description: [
      "We deliver result-driven digital marketing strategies using SEO, social media, and campaigns to increase visibility, engagement, and strong brand growth online.",

      "Authoritatively scale business meta-services before client-based technologies. Collaboratively strategize synergistic scenarios rather than flexible action items. Continually deliver market positioning convergence and mission-critical infrastructures.",
    ],

    videoSection: {
      image: "/assets/img/service/service_inner_1.jpg",
      videoUrl: "https://www.youtube.com/watch?v=_sI_Ps7JSEk",
    },

    checklistTitle: "We Serve The Best Work",
    checklist: [
      "Up am intention on dependent questions",
      "Surrounded affronting favourable",
      "Sed ut perspiciatis unde omnis iste natus",
      "Special Careness Risk Free",
      "Bibend auctor nisi elit volume are beguiled",
    ],

    extraDescription:
      "Credibly brand accurate data after user friendly ROI. Professionally negotiate inexpensive markets and team driven scenarios. Interactively seize wireless e-tailers after resource maximizing content. Collaboratively leverage existing.",

    benefitsTitle: "Benefits With Our Service",

    features: [
      {
        icon: "/assets/img/icon/service_feature_1.svg",
        title: "Flexible Solutions",
        text: "Completely grow multimedia based content before global scenarios.",
      },
      {
        icon: "/assets/img/icon/service_feature_2.svg",
        title: "24/7 Unlimited Support",
        text: "Completely grow multimedia based content before global scenarios.",
      },
    ],
  },
  {
    id: 4,
    number: "04",
    img: "/assets/img/service/service_box_4.jpg",
    icon: "/assets/img/icon/service_box_4.svg",
    title: "Business Analysis",
    bgShape: "/assets/img/bg/service_card_bg.png",
    description: [
      "We analyze business processes using data-driven methods to identify opportunities, improve efficiency, and support smarter decision making for growth.",

      "Authoritatively scale business meta-services before client-based technologies. Collaboratively strategize synergistic scenarios rather than flexible action items. Continually deliver market positioning convergence and mission-critical infrastructures.",
    ],

    videoSection: {
      image: "/assets/img/service/service_inner_1.jpg",
      videoUrl: "https://www.youtube.com/watch?v=_sI_Ps7JSEk",
    },

    checklistTitle: "We Serve The Best Work",
    checklist: [
      "Up am intention on dependent questions",
      "Surrounded affronting favourable",
      "Sed ut perspiciatis unde omnis iste natus",
      "Special Careness Risk Free",
      "Bibend auctor nisi elit volume are beguiled",
    ],

    extraDescription:
      "Credibly brand accurate data after user friendly ROI. Professionally negotiate inexpensive markets and team driven scenarios. Interactively seize wireless e-tailers after resource maximizing content. Collaboratively leverage existing.",

    benefitsTitle: "Benefits With Our Service",

    features: [
      {
        icon: "/assets/img/icon/service_feature_1.svg",
        title: "Flexible Solutions",
        text: "Completely grow multimedia based content before global scenarios.",
      },
      {
        icon: "/assets/img/icon/service_feature_2.svg",
        title: "24/7 Unlimited Support",
        text: "Completely grow multimedia based content before global scenarios.",
      },
    ],
  },
  {
    id: 5,
    number: "05",
    img: "/assets/img/service/service_box_5.jpg",
    icon: "/assets/img/icon/service_box_5.svg",
    title: "Software Services",
    bgShape: "/assets/img/bg/service_card_bg.png",
    description: [
      "We provide custom software development services using modern technologies to build reliable, scalable, and secure digital solutions tailored to business needs.",

      "Authoritatively scale business meta-services before client-based technologies. Collaboratively strategize synergistic scenarios rather than flexible action items. Continually deliver market positioning convergence and mission-critical infrastructures.",
    ],

    videoSection: {
      image: "/assets/img/service/service_inner_1.jpg",
      videoUrl: "https://www.youtube.com/watch?v=_sI_Ps7JSEk",
    },

    checklistTitle: "We Serve The Best Work",
    checklist: [
      "Up am intention on dependent questions",
      "Surrounded affronting favourable",
      "Sed ut perspiciatis unde omnis iste natus",
      "Special Careness Risk Free",
      "Bibend auctor nisi elit volume are beguiled",
    ],

    extraDescription:
      "Credibly brand accurate data after user friendly ROI. Professionally negotiate inexpensive markets and team driven scenarios. Interactively seize wireless e-tailers after resource maximizing content. Collaboratively leverage existing.",

    benefitsTitle: "Benefits With Our Service",

    features: [
      {
        icon: "/assets/img/icon/service_feature_1.svg",
        title: "Flexible Solutions",
        text: "Completely grow multimedia based content before global scenarios.",
      },
      {
        icon: "/assets/img/icon/service_feature_2.svg",
        title: "24/7 Unlimited Support",
        text: "Completely grow multimedia based content before global scenarios.",
      },
    ],
  },
  {
    id: 6,
    number: "06",
    img: "/assets/img/service/service_box_1.jpg",
    icon: "/assets/img/icon/service_box_1.svg",
    title: "IT Management",
    bgShape: "/assets/img/bg/service_card_bg.png",
    description: [
      "We offer complete IT management services including infrastructure support, system monitoring, and maintenance to ensure smooth, secure, and stable operations.",

      "Authoritatively scale business meta-services before client-based technologies. Collaboratively strategize synergistic scenarios rather than flexible action items. Continually deliver market positioning convergence and mission-critical infrastructures.",
    ],

    videoSection: {
      image: "/assets/img/service/service_inner_1.jpg",
      videoUrl: "https://www.youtube.com/watch?v=_sI_Ps7JSEk",
    },

    checklistTitle: "We Serve The Best Work",
    checklist: [
      "Up am intention on dependent questions",
      "Surrounded affronting favourable",
      "Sed ut perspiciatis unde omnis iste natus",
      "Special Careness Risk Free",
      "Bibend auctor nisi elit volume are beguiled",
    ],

    extraDescription:
      "Credibly brand accurate data after user friendly ROI. Professionally negotiate inexpensive markets and team driven scenarios. Interactively seize wireless e-tailers after resource maximizing content. Collaboratively leverage existing.",

    benefitsTitle: "Benefits With Our Service",

    features: [
      {
        icon: "/assets/img/icon/service_feature_1.svg",
        title: "Flexible Solutions",
        text: "Completely grow multimedia based content before global scenarios.",
      },
      {
        icon: "/assets/img/icon/service_feature_2.svg",
        title: "24/7 Unlimited Support",
        text: "Completely grow multimedia based content before global scenarios.",
      },
    ],
  },
];

export default services;
